<template>
    <div>
        <p class="first_content" v-if="ismock">
            <span class="requirements"><span class="require_title">作业要求：</span>{{description}}</span>
            <span class="comment">
                <span class="requirement_detail" @click='look_detail'>详情</span>
                <!-- <el-button plain size="middle" @click='default_comment'>默认语点评</el-button> -->
                <!-- <el-button plain size="middle" @click='ueditor_flag = true'>整体点评</el-button> -->
            </span>
        </p>
        <div class="content_box">
            <div class="content_left">
                <p class="level_font">{{leveldata.level_name}}</p>
                <p>答对：<span class="correct_ques">{{leveldata.correct_num}}/{{leveldata.total_num}}</span>
                    <span class="proportion">正确率：<span class="correct_ques">{{(leveldata.correct_num/leveldata.total_num*100).toFixed()}}%</span></span>
                </p>
                <div v-for='i in leveldata.children'>
                  <div v-if='i.children'>
                    <p class="hierarchy">{{i.level_name}}</p>
                    <p class="answers_choose">答对：<span class="correct_ques">{{i.correct_num}}/{{i.total_num}}</span>
                        <span class="proportion">正确率：<span class="correct_ques">{{(i.correct_num/i.total_num*100).toFixed()}}%</span></span>
                    </p>
                    <p class="level_data">
                        <span class="item_question" v-for='(item, index) in i.children' :class='(item.form == 4 || item.user_answer == "")?"item_form":""'>{{index+1}}
                            <span v-if='item.is_correct == 1&&item.form !=4' class="answers"></span>
                            <span v-else-if='item.form !=4&&item.user_answer' class="answers answered"></span>
                            <span v-if='item.is_signed == 1' class="signed"></span>
                        </span>
                    </p>
                  </div>
                </div>
                <div class="level_data">
                  <div v-for='(i, idx) in leveldata.children' v-if='!i.children'>
                    <span class="item_question" :class='(i.form == 4 || i.user_answer == "")?"item_form":""'>{{idx+1}}
                      <span v-if='i.is_correct == 1&&i.form !=4' class="answers"></span>
                      <span v-else-if='i.form !=4&&i.user_answer' class="answers answered"></span>
                      <span v-if='i.is_signed == 1' class="signed"></span>
                    </span>
                  </div>
                </div>
                <p class="level_font">试题考点</p>
                <div v-for='(item, idx) in leveldata.children'>
                  {{item.subject}}
                </div>
            </div>
            <div class="content_right">
                <div class="content_right__wraper">
                  <part-comments id="ueditor_comments" ref="ueditor_comments">
                    <p>点评</p>
                  </part-comments>
                  <!-- <questions></questions> -->
                </div>
            </div>
        </div>
        <el-dialog title="默认语点评" :visible.sync="default_flag">
            <div class="defaultTip">（填写默认语后，作业全部题目都使用当前评语）</div>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入"
              :readonly="!can_edit"
              v-model="defaultComment">
            </el-input>
            <div class="defaultCommentError" v-if="defaultComment === ''">请填写默认点评</div>
            <span slot="footer" class="dialog-footer" v-show="can_edit">
              <el-button @click="default_flag = false">取 消</el-button>
              <el-button type="primary" @click="saveComments('default')">应用</el-button>
            </span>
        </el-dialog>
        <el-dialog title="整体点评" :visible.sync="ueditor_flag">
            <p style="position: relative;">
              <comments id="ueditor_comments2" ref="ueditor_comments2" :allCommentsDialog="true">
              </comments>
            </p>
            <span slot="footer" class="dialog-footer" v-show="can_edit">
              <el-button @click="ueditor_flag = false">取 消</el-button>
              <el-button type="primary" @click="saveComments">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import VideoPlayer from '@/components/video-player'
    import global_ from "../../global/index"
    import Comments from '@/components/ueditor/comments'
    import PartComments from '@/components/ueditor/part-comments'
    // import Questions from '@/components/questions/index'

    export default {
        data() {
          return {
              ueditor_flag: false,
              default_flag: false,
              defaultComment: '',
              can_edit: true,
              description: window.localStorage.getItem('description'),
              writConfig: {
                // enableAutoSave: false,
                readonly: false,
                initialFrameHeight: 200,
                elementPathEnabled: false, // 不显示元素路径
                zIndex: 9,
                maximumWords: 500,
                toolbars: [[
                    'bold',
                    'italic',
                    'forecolor',
                    'insertimage',
                    // 'underline',
                    // 'simpleupload',
                    // 'spechars',
                    'kityformula',
                    // 'fontpoint',
                    // 'emptyunderline',
                    'emotion'
                ]],
                enterTag : 'br',
                // serverUrl: 'http://35.201.165.105:8000/controller.php'
              },
              ismock: this.$route.params.object_type == 2?false: true
          };
        },
        computed: {
          config () {
            return this.writConfig;
          },
          leveldata(){
            return this.$store.state.app.leveldata
          },
          comments: {
            get () {
              return this.$store.state.app.comments
            },
            set (value) {
              this.$store.commit('setComments', value)
            }
          },
          upload: {
            get () {
              return this.$store.state.app.upload
            },
            set (value) {
              this.$store.commit('setUpload', value)
            }
          },
          audio: {
            get () {
              return this.$store.state.app.audio
            },
            set (value) {
              this.$store.commit('setAudio', value)
            }
          },
          attachmentFilesList: {
            get () {
              return this.$store.state.app.attachmentFilesList
            },
            set (value) {
              this.$store.commit('setAttachmentFilesList', value)
            }
          }
        },
        components: {
          Comments,
          PartComments
          // Questions
        },
        created () {
          if (this.$route.params.correct_user.indexOf(localStorage.getItem('user_no')) != -1) {
            this.can_edit = true
          } else {
            this.can_edit = false
          }
        },
        methods:{
            default_comment(){
              this.default_flag = true
              this.getExerciseCorrectRet()
            },
            look_detail(){
                this.$alert(window.localStorage.getItem('description'), '作业要求', {
                    showConfirmButton: false
                });
            },
            // 获取默认点评内容
            getExerciseCorrectRet () {
              this.defaultComment = ''
              const { exercise_id, record_id, object_type } = this.$route.params
              let params = {
                exercise_id: exercise_id,
                record_id: record_id,
                comment_type: 1,
                level_no: 0,
                comment_object_id: 0,
                object_type: object_type
              }
              params.correct_from = this.$route.query.correct_from ? this.$route.query.correct_from : 1
              this.$api.GETEXERCISECORRECTRET(params).then(res => {
                if (res.retcode === 0) {
                  let result = res.data
                  this.defaultComment = result.remark
                }
              })
            },
            saveComments (flag) {
              if (flag === 'default') {
                if (this.defaultComment === '') {
                  return
                }
              }
              const {
                comment_type,
                exercise_id,
                record_id,
                correct_user,
                object_type,
                object_id,
                tiku_user_id,
                sso_id,
                correct_score,
                level_no,
                comment_object_id
              } = this.$route.params
              let params = {
                comment_type: 0,
                exercise_id: exercise_id,
                record_id: record_id,
                correct_user: correct_user,
                object_type: object_type,
                object_id: object_id,
                tiku_user_id: tiku_user_id,
                sso_id: sso_id,
                correct_score: correct_score,
                level_no: 0,
                comment_object_id: ''
              }
              if (flag === 'default') {
                params.comment_text = this.defaultComment
                params.comment_type = 1 // 默认语点评
              } else {
                params.comment_text = this.comments
              }
              let appendant = []
              if (this.upload.media_id) {
                let uploadObj = {
                  file_url: this.upload.url,
                  file_type: this.upload.type,
                  is_lock: 0,
                  media_id: this.upload.media_id,
                  file_name: ''
                }
                // uploadObj = JSON.stringify(uploadObj)
                appendant.push(uploadObj)
              }
              if (this.audio.media_id) {
                let audioObj = {
                  file_url: this.audio.url,
                  file_type: this.audio.type,
                  is_lock: 0,
                  media_id: this.audio.media_id,
                  file_name: ''
                }
                appendant.push(audioObj)
              }
              if (this.attachmentFilesList.length > 0) {
                this.attachmentFilesList.map((item) => {
                  item.pop_flag = 0
                })
                appendant = [...appendant, ...this.attachmentFilesList]
              }
              params.appendant = JSON.stringify(appendant)
              console.log(params)
              params.correct_from = this.$route.query.correct_from ? this.$route.query.correct_from : 1
              this.$api.SAVECOMMENT(params).then(res => {
                if (res.retcode === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success',
                    onClose: () => {
                    }
                  });
                  this.ueditor_flag = false
                  this.default_flag = false
                } else {
                  this.$message.error(res.message)
                }
              })
            }
        }
    }
</script>

<style lang="less" scoped>
.el-dialog__wrapper{
  z-index: 10;
}
.v-modal{
  z-index: 9!important;
}
    .first_content{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 10px;
        margin: 0;
        .requirements{
            width: 680px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #7d829a;
            font-size: 14px;
            .require_title{
                color: #2a2e3d;
                font-weight: bold;
            }
        }
        .requirement_detail{
            margin-left: 20px;
        }
        .comment{
            float: right;
            .requirement_detail{
                font-size: 14px;
                margin-right: 15px;
                color: #6594fe;
                cursor: pointer;
            }
        }
        .el-button{
            color: #6594fe;
            border: 1px solid #6594fe;
        }
    }
    .content_box{
        display: flex;
        .content_left{
            flex: 1;
            .hierarchy{
                margin: 0;
                font-size: 14px;
            }
            .answers_choose{
                font-size: 14px;
            }
            .level_font{
                font-weight: bold;
                position: relative;
                padding-left: 10px;
                font-size: 14px;
            }
            .level_font::before{
                content: "";
                position: absolute;
                left: 0;
                top: 3px;
                height: 16px;
                width: 4px;
                border-radius: 2px;
                background-color: #6594fe;
            }
            .correct_ques{
                color: #6594fe;
                font-weight: bold;
            }
            .proportion{
                margin-left: 20px;
            }
            .level_data{
                width: 420px;
                display: flex;
                flex-wrap: wrap;
                .item_question{
                    position: relative;
                    display: inline-block;
                    width: 32px;
                    height: 32px;
                    font-size: 12px;
                    color: #6594fe;
                    background: #f0f0f0;
                    text-align: center;
                    line-height: 30px;
                    border-radius: 4px;
                    border: 1px solid #f0f0f0;
                    margin-right: 10px;
                    margin-bottom: 10px;
                    .answers{
                        position: absolute;
                        top: -1px;
                        left: -1px;
                        width: 12px;
                        height: 12px;
                        background: url(../../../static/images/correct.png);
                        background-size: cover;
                    }
                    .answered{
                        background: url(../../../static/images/wrong.png);
                    }
                    .signed{
                        position: absolute;
                        right: -5px;
                        top: -5px;
                        width: 12px;
                        height: 12px;
                        background: url(../../../static/images/flag.png);
                        background-size: cover;
                    }
                }
                .item_form{
                  background: #fff;
                  color: #7d829a;
                }
            }
        }
        .content_right{
            width: 370px;
            border-left: 1px solid #e5e5e5;
            .content_right__wraper{
              margin-left: 27px;
              width: 342px;
            }
        }
    }
    .el-textarea__inner{
        resize:none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/homework-second/index.vue